import { Snackbar as MuiSnackbar, Alert } from '@mui/material';
import { type ConnectedProps, connect } from 'react-redux';
import { type RootState } from '@/store';
import {
  isSnackbarOpen,
  snackbarType,
  snackbarMessage,
  closeSnackbar,
} from '../state';
import styles from './styles';

type Props = ConnectedProps<typeof connector>;

const Snackbar = ({
  isSnackbarOpen,
  snackbarType,
  snackbarMessage,
  closeSnackbar,
}: Props) => {
  const handleClose = () => {
    closeSnackbar();
  };

  return (
    isSnackbarOpen && (
      <MuiSnackbar
        key={snackbarMessage}
        slots={{
          clickAwayListener: ({ children }) => children,
        }}
        open={isSnackbarOpen}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        autoHideDuration={6000}
      >
        <Alert
          onClose={handleClose}
          severity={snackbarType}
          variant="filled"
          sx={styles.alert}
        >
          {snackbarMessage}
        </Alert>
      </MuiSnackbar>
    )
  );
};

const connector = connect(
  (state: RootState) => ({
    isSnackbarOpen: isSnackbarOpen(state),
    snackbarType: snackbarType(state),
    snackbarMessage: snackbarMessage(state),
  }),
  { closeSnackbar },
);

export default connector(Snackbar);
